<template>
  <div :class="keyboardClass"></div>
</template>

<script>
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";
import layout from "../assets/urdu"

export default {
  name: "SimpleKeyboard",
  props: {
    keyboardClass: {
      default: "simple-keyboard",
      type: String
    },
    input: {
      type: String
    },
    inputName: {
      type: String
    },
    classes: {
      type: String
    }
  },
  data: () => ({
    keyboard: null
  }),
  mounted() {
    this.keyboard = new Keyboard({
      onChange: this.onChange,
      inputName: this.inputName,
      display: {
        '{bksp}': '&emsp; \u2190 &emsp;',
        '{space}': '&emsp;&emsp;&emsp;&emsp; &emsp;&emsp;&emsp;&emsp;'
      },
      buttonTheme: [{
        class: this.getClass(),
        buttons: "\u0636 \u0635 \u0691 \u0688 \u063A \u0621 \u062E {bksp} " +
        "\u0642 \u0648 \u0639 \u0631 \u062A \u06D2 \u0649 \u06C1 \u067E " +
        "\u0627 \u0633 \u062F \u0641 \u06AF \u062D \u062C \u06A9 \u0644 " +
        "\u0632 \u0634 \u0686 \u0637 \u0628 \u0646 \u0645 " +
        "\u0630 \u062B {space} \u06BA \u0638 "
      }],
      ...layout
    });
  },
  methods: {
    onChange(input) {
      this.$emit("onChange", input);
    },
    getClass() {
      return (this.$vuetify.theme.dark) ? "grey darken-4" : "white"
    }
  },
  watch: {
    inputName(inputName) {
      this.keyboard.setOptions({ inputName });
    },
    input(input) {
      this.keyboard.setInput(input);
    },
  }
};
</script>

<style scoped>
div {
  font-size: 1.5rem;
}
</style>